import { cn } from '@/lib/cn';

interface AvatarProps {
  name: string;
  className?: string;
}

const initialsFrom = (name: string): string => {
  const parts = name.split(/[@\s_.-]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
};

// Deterministic color from email/name so each user has a stable accent
// without us tracking it server-side.
const colorFor = (name: string): string => {
  const palette = [
    'bg-blue-100 text-blue-800',
    'bg-purple-100 text-purple-800',
    'bg-pink-100 text-pink-800',
    'bg-amber-100 text-amber-800',
    'bg-emerald-100 text-emerald-800',
    'bg-cyan-100 text-cyan-800',
    'bg-rose-100 text-rose-800',
    'bg-indigo-100 text-indigo-800',
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  const index = Math.abs(hash) % palette.length;
  return palette[index]!;
};

export function Avatar(props: AvatarProps) {
  const { name, className } = props;
  return (
    <span
      className={cn(
        'inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold',
        colorFor(name),
        className,
      )}
      aria-hidden
    >
      {initialsFrom(name)}
    </span>
  );
}
